//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 } from 'uuid'
import { ChevronDownIcon } from '@vue-hero-icons/outline'
import { classArray } from '../../utils/class'
export default {
  components: { ChevronDownIcon },
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
      validator(options) {
        return !options.some(
          ({ value, text }) =>
            typeof value === 'undefined' || typeof text !== 'string',
        )
      },
    },
    selectClasses: {
      type: [String, Array],
      default: '',
    },
    dataTestId: {
      type: String,
      default: null,
    },
    chooseLabel: {
      type: String,
      default: 'Choose',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: 'form-select-' + v4(),
      hasFocus: false,
    }
  },

  computed: {
    localOptions() {
      return this.$slots.placeholderOption
        ? this.options
        : [
            {
              value: null,
              text: this.chooseLabel,
              disabled: true,
              selected: true,
            },
            ...this.options,
          ]
    },
    computedLabel() {
      if (this.required && this.label && !this.label.includes('*')) {
        return this.label + '*'
      }
      return this.label
    },
    classForSelect() {
      const cls = []

      if (this.value && this.label) {
        cls.push('tw-pt-5 tw-pb-1 md:tw-pt-6 md:tw-pb-2')
      } else {
        cls.push('tw-py-3 md:tw-py-4')
      }

      if (this.selectClasses) {
        cls.push(this.selectClasses)
      }

      return classArray(this.selectClasses).concat(cls)
    },
  },

  methods: {
    onFocus(e) {
      this.hasFocus = true
      this.$emit('focus', e)
    },
    onBlur(e) {
      this.hasFocus = false
      this.$emit('blur', e)
    },
  },
}
